<script>
import propsMixin from './mixins/propsMixin.vue';
import Confirm1Dialog from './types/Confirm1Dialog.vue';
import Error1Dialog from './types/Error1Dialog.vue';
import Confirm2Dialog from './types/Confirm2Dialog.vue';
import Error2Dialog from './types/Error2Dialog.vue';
import Confirm3Dialog from './types/Confirm3Dialog.vue';
import Error3Dialog from './types/Error3Dialog.vue';

export default {
  mixins: [propsMixin],
  // dialog components types
  components: {
    Confirm1Dialog,
    Error1Dialog,
    Confirm2Dialog,
    Error2Dialog,
    Confirm3Dialog,
    Error3Dialog,
  },

  props: {
    type: {
      type: String,
      required: true,
    },
  },

  render(createElement) {
    const dialogType = _.kebabCase(`${this.type}-dialog`);

    return createElement(dialogType, {
      props: this.$props,
    });
  },
};
</script>
